<template>
    <div class="py-12 px-6">
        <div class="prose max-w-5xl mx-auto dark:text-white dark:prose-headings:text-white">
            <h1 class="text-2xl font-bold text-center">RoValue.com Community Guidelines</h1>
            <p>Effective Date: September 17th 2024</p>

            <p>RoValue.com is committed to creating a respectful, safe, and inclusive community for all users. By participating in our community, you agree to follow these guidelines to ensure a positive experience for everyone.</p>

            <h3>1. Respectful Communication</h3>
            <p>Be Kind and Respectful: Treat all community members with respect. Any form of harassment, bullying, or hate speech will not be tolerated. This includes discrimination based on race, ethnicity, gender, sexual orientation, religion, or other personal characteristics.</p>
            <p>No Personal Attacks: Disagreements are natural, but personal attacks, insults, or inflammatory remarks are not allowed.</p>

            <h3>2. No Scamming or Fraud</h3>
            <p>Honesty in Trades: When engaging in trades or deals on RoValue.com, ensure that all information shared is accurate and that both parties fulfill their commitments. Misrepresentation, scams, or fraudulent behavior is strictly prohibited.</p>
            <p>Middleman Usage: When conducting high-value trades, we recommend using a verified middleman service to ensure fairness and security.</p>

            <h3>3. Content Posting</h3>
            <p>No Spam: Avoid spamming the forums, trade sections, or chat with irrelevant or repetitive content. Keep posts constructive and relevant to the community.</p>
            <p>No Offensive Content: Do not post content that is explicit, pornographic, obscene, or otherwise inappropriate for the community. This includes offensive usernames or profile pictures.</p>

            <h3>4. Respect Privacy</h3>
            <p>Do Not Share Personal Information: For your safety, do not share personal or sensitive information, such as home addresses, phone numbers, or passwords, publicly on RoValue.com.</p>
            <p>No Doxxing: Sharing another user's personal information without their consent is strictly prohibited and will result in immediate action.</p>

            <h3>5. Fair Use of the Platform</h3>
            <p>No Hacking or Exploiting: Any attempt to hack, exploit vulnerabilities, or disrupt the functionality of RoValue.com is strictly forbidden and will result in permanent suspension.</p>
            <p>Follow the Rules of Engagement: Trades and interactions on the platform should be done in good faith. Any attempt to manipulate or exploit the trade system will result in penalties.</p>

            <h3>6. Constructive Participation</h3>
            <p>Provide Helpful Feedback: When giving feedback on trades, services, or other aspects of the site, be constructive and polite. Negative comments should be focused on the issue, not the person.</p>
            <p>Encourage New Users: RoValue.com welcomes new members! Please offer help and guidance where needed to ensure everyone can enjoy the community.</p>

            <h3>7. Reporting Violations</h3>
            <p>Use Reporting Tools: If you encounter a violation of these guidelines, use the site’s reporting tools to notify moderators. Abuse of the reporting system will not be tolerated.</p>

            <h3>8. Consequences for Violations</h3>
            <p>Violations of these guidelines may result in:</p>
            <ul>
                <li>Temporary or permanent suspension of your account.</li>
                <li>Removal of content or posts deemed inappropriate.</li>
                <li>A ban from trading or interacting with other users.</li>
            </ul>

            <h3>9. No abuse of Communication Systems</h3>
            <p>Use RoValue.com tools and our system properly. False reporting will result in moderation and a report blacklist.</p>

            <h3>10. Moderation and Updates</h3>
            <p>RoValue.com reserves the right to update or modify these Community Guidelines as needed. Moderators will enforce these guidelines to maintain a positive environment.</p>
            <p>We encourage all users to be respectful, honest, and supportive. By adhering to these guidelines, we can maintain a safe and enjoyable community for everyone. Happy trading!</p>
        </div>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
    title: 'Community Guidelines'
})
</script>